module.exports = __webpack_public_path__ + "img/art-composer-postcard-alt.7bb1169c.png";